export default __webpack_public_path__ + "static/media/cloud-engineer-logo.ce650230.svg";